// extracted by mini-css-extract-plugin
export default {"fnav":"navigation_fnav__xGFtN","contact":"navigation_contact__9tprE","socials":"navigation_socials__y2Q+1","logo":"navigation_logo__IprXt","nav":"navigation_nav__SfV70"};